import { createSlice } from "@reduxjs/toolkit";
import { LP_Progress } from "../learningPath";

const INIT_STATE: { data: LP_Progress } = { data: {} as LP_Progress };

const LearningPathProgressSlice = createSlice({
  name: "LearningPathProgressSlice",
  initialState: INIT_STATE,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    }
  }
});

export default LearningPathProgressSlice;

export const LearningPathProgressSliceActions =
  LearningPathProgressSlice.actions;
